import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Hidden,
  Icon
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import PageHeader from 'src/views/Common/PageHeader';
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import tokenDecoder from '../../../utils/tokenDecoder';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CountUp from 'react-countup';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecordAndNew: {
    backgroundColor: "#FFBE00"
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

var screenCode = "ACCOUNTPAYABLE"
export default function AccountPayableAddEdit() {

  const navigate = useNavigate();
  const alert = useAlert();
  const { referenceNumber } = useParams();
  const { invoiceDetailID } = useParams();
  const { groupID } = useParams();
  const { factoryID } = useParams();
  const [title, setTitle] = useState("Account Payable")
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const classes = useStyles();
  const [factories, setFactories] = useState();
  const [groups, setGroups] = useState();
  const [voucherTypes, setVoucherTypes] = useState([]);
  const [transactionModes, setTransactionModes] = useState([]);
  const [refNo, setRefNo] = useState();
  const [voucherCode, setVoucherCode] = useState();
  const [selectedTransactionDate, handleTransactionDateChange] = useState(new Date());
  const [selectedInvoicenDate, handleInvoiceDateChange] = useState(new Date());
  const [selectedDueDate, handleDueDateChange] = useState(new Date().toISOString());
  const [financialYearStartDate, setFinancialYearStartDate] = useState();
  const [dateDisable, setDateDisable] = useState(false);
  const [journalData, setJournalData] = useState([]);
  const [childHeaderNames, setChildHeaderNames] = useState([]);
  const [accountTypeNames, setAccountTypeNames] = useState([]);
  const [status, setStatus] = useState(0);
  const [recordAndNewBtnEnable, setRecordAndNewBtnEnable] = useState();
  const [approveButtonEnabled, setApproveButtonEnabled] = useState(false);
  const [isInterStatus, setIsInterStatus] = useState(false);
  const [voucherCodeRef, setVoucherCodeRef] = useState();
  const [accountDescriptions, setAccountDescriptions] = useState({});
  const [accountDescriptionsType, setAccountDescriptionsType] = useState({});
  const [suppliersAuto, setSuppliersAuto] = useState();
  const [suppliers, setSuppliers] = useState();
  const [tranLedgerList, setTranLedgerList] = useState([]);
  const [refNoInter, setRefNoInter] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [isCleared, setIsCleared] = useState(false);
  const [journalDataCreditRecordUpdate, setJournalDataCreditRecordUpdate] = useState({});
  const [supplierInvoiceNumbers, setSupplierInvoiceNumbers] = useState([]);
  const [supplierID, setSupplierID] = useState(0);
  const [invoiceDetail, setInvoiceDetail] = useState({
    invoiceID: '0',
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveButtonEnabled: false
  });
  const [accountPayable, setAccountPayable] = useState({
    groupID: parseInt(tokenService.getGroupIDFromToken()),
    factoryID: parseInt(tokenService.getFactoryIDFromToken()),
    transactionTypeID: '0',
    referenceNumber: '',
    payableReferenceNumber: '',
    description: '',
    payableDescription: '',
    descriptionTypeID: 0,
    payModeID: '0',
    chequeNumber: '',
    isActive: true,
    preparedBy: '',
    updatedBy: '',
    voucherType: '0',
    voucherCode: '',
    transactionMode: '0',
    recipientName: '',
    address: '',
    isInterEstate: false,
    interEstateID: '0',
    supplierID: '0',
    invoiceNo: '',
    tranLedgerAccountID: '0',
  });

  const maxDate = new Date();
  const handleClick = () => {
    navigate('/app/accountPayable/listing');
  }

  let decrypted = 0;
  let decryptedVoucherCode = 0;
  let decryptedfactoryID = 0;
  let decryptedgroupID = 0

  useEffect(() => {
    getPermissions();
    getGroupsForDropdown();
  }, []);

  useEffect(() => {
    if (accountPayable.groupID.toString() !== "0") {
      trackPromise(getfactoriesForDropDown());
    }
  }, [accountPayable.groupID]);

  useEffect(() => {
    if (accountPayable.isInterEstate && parseInt(accountPayable.interEstateID) !== 0) {
      trackPromise(getReferenceNumberInter());
    }
  }, [voucherCodeRef, accountPayable.isInterEstate, accountPayable.interEstateID]);

  useEffect(() => {
    if (accountPayable.factoryID.toString() !== "0") {
      trackPromise(getChildHeaderNames(accountPayable.groupID, accountPayable.factoryID));
      trackPromise(getVoucherTypeList());
      trackPromise(getTransactionModeList());
      trackPromise(getFinancialYearStartEndDate());
      trackPromise(getTranLedgerList());
      trackPromise(getSuppliersForDropDown(), getSuppliersForDropDownAuto());
      if (!isUpdate) {
        trackPromise(getReferenceNumber('SIAP'));
      }
    }
  }, [accountPayable.factoryID]);

  useEffect(() => {
    if (referenceNumber && isUpdate) {
      const decodedRefNo = atob(referenceNumber);
      setAccountPayable(prev => ({
        ...prev,
        referenceNumber: decodedRefNo
      }));
    }
  }, [referenceNumber]);

  useEffect(() => {
    decrypted = atob(invoiceDetailID.toString());
    decryptedVoucherCode = atob(referenceNumber.toString());
    decryptedgroupID = atob(groupID.toString());
    decryptedfactoryID = atob(factoryID.toString());
    if (decrypted != 0) {
      trackPromise(getAccountPayableDetails(decrypted, decryptedVoucherCode, decryptedgroupID, decryptedfactoryID));
      setInvoiceDetail({
        invoiceID: parseInt(decrypted)
      });
    } else {
      setJournalData([
        {
          accountTypeName: 0,
          childHeaderName: 0,
          credit: 0,
          debit: 0,
          description: undefined,
          ledgerTransactionID: 0,
          rowID: GenerateRandomID()
        }
      ])
    }
  }, []);

  useEffect(() => {
    const lastInvoiceNumber = localStorage.getItem('lastInvoiceNumber') || "REF0000";
    generateNextInvoiceNumber(lastInvoiceNumber);
  }, []);

  useEffect(() => {
    if (!isUpdate) {
      setAccountPayable({
        ...accountPayable,
        transactionMode: '0',
        tranLedgerAccountID: '0'
      })
      setIsCleared(!isCleared);
    }
  }, [accountPayable.groupID, accountPayable.factoryID]);

  useEffect(() => {
    if (!isUpdate) {
      setAccountPayable({
        ...accountPayable,
        supplierID: '0',
      })
    }
  }, [accountPayable.transactionMode]);

  useEffect(() => {
    if (supplierID !== 0) {
      getSupplierInvoiceNumbersBySupplier();
    }
  }, [supplierID]);

  const generateNextInvoiceNumber = (lastInvoiceNumber) => {
    const numericPart = parseInt(lastInvoiceNumber.slice(3), 10) + 1;
    const newInvoiceNumber = `REF${numericPart.toString().padStart(4, '0')}`;
    //setInvoiceNumber(newInvoiceNumber);
    localStorage.setItem('lastInvoiceNumber', newInvoiceNumber);
  };

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITACCOUNTPAYABLE');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isApproveButtonEnabled = permissions.find(p => p.permissionCode == 'ACCOUNTPAYABLEAPPROVEBUTTONENABLED');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isApproveButtonEnabled: isApproveButtonEnabled !== undefined,
    });

    setAccountPayable({
      ...accountPayable,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getReferenceNumber(voucherCode) {
    let refModel = {
      groupID: accountPayable.groupID,
      factoryID: accountPayable.factoryID,
      date: selectedTransactionDate.toISOString().split('T')[0],
      voucherCode: voucherCode
    }
    const ref = await services.getReferenceNumber(refModel);
    const refNo = `REF${ref.data.replace(/^SIAP/, "")}`;
    setInvoiceNumber(refNo);
    setRefNo(ref.data);
  }

  async function getSupplierInvoiceNumbersBySupplier() {
    const response = await services.getSupplierInvoiceNumbersBySupplier(accountPayable.groupID, accountPayable.factoryID, supplierID);
    setSupplierInvoiceNumbers(response.data);
  }

  async function getReferenceNumberInter() {
    if (accountPayable.isInterEstate) {
      let refModel = {
        groupID: accountPayable.groupID,
        factoryID: accountPayable.interEstateID,
        date: selectedTransactionDate.toISOString().split('T')[0],
        voucherCode: voucherCodeRef
      };
      const ref = await services.getReferenceNumber(refModel);
      setRefNoInter(ref.data);
    }
  }

  async function getAccountDescriptionsNormal(accID) {
    const accountDescriptions = await services.getAccountDescriptionsNormal(accID);
    setAccountDescriptionsType(accountDescriptions);
  }

  async function getAccountTypeNames(childHeaderModel) {
    const accounts = await services.getLedgerAccountNamesForDatagrid(childHeaderModel);
    setAccountTypeNames(accounts);
    return accounts;
  }

  async function getChildHeaderNames(groupID, factoryID) {
    const childHeaders = await services.getChildHeaderNamesForDatagrid(groupID, factoryID);
    setChildHeaderNames(childHeaders);
  }

  async function getFinancialYearStartEndDate() {
    const yearDate = await services.getFinancialYearStartDateByGroupIDFactoryID(accountPayable.groupID, accountPayable.factoryID);
    if (yearDate !== null) {
      setFinancialYearStartDate(yearDate.financialYearStartDate);
      setDateDisable(false);
    }
    else {
      setDateDisable(true);
      setFinancialYearStartDate(new Date());
    }
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(accountPayable.groupID);
    setFactories(factory);
  }

  async function getSuppliersForDropDownAuto() {
    const supplierResult = await services.getSuppliersForDropDownAuto(
      accountPayable.factoryID
    );
    let result = supplierResult.map((u) => ({ supplierName: u.supplierName, supplierID: u.supplierID }));
    setSuppliersAuto(result);
  }

  function generateDropDownMenuWithTwoValues(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items
  }

  async function getSuppliersForDropDown() {
    const supplierResult = await services.getSuppliersForDropDown(
      accountPayable.factoryID
    );
    setSuppliers(supplierResult);
  }

  function handleChangeSupplier(e, data) {

    const value = e.supplierID;
    setAccountPayable({
      ...accountPayable,
      supplierID: value
    });
    setSupplierID(value);
  }

  function handleInvoiceNoChange(e) {
    const value = e.target.value;

    setAccountPayable({
      ...accountPayable,
      invoiceNo: value
    });
  }

  async function getAccountPayableDetails(invoiceDetailID, referenceNumber, groupID, factoryID) {
    let model = {
      invoiceDetailID: parseInt(invoiceDetailID),
      groupID: parseInt(groupID),
      factoryID: parseInt(factoryID),
      referenceNumber: referenceNumber && referenceNumber.toString().trim() !== "" ? referenceNumber.toString() : null,
    };
    let response = await services.getAccountPayableDetailsByReferenceNumber(model);
    let data = response;

    setTitle("Update Account Payable");
    setIsUpdate(true);
    setAccountPayable({
      ...accountPayable,
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      transactionTypeID: data[0].transactionTypeID,
      referenceNumber: data[0].referenceNumber,
      description: data[0].description,
      descriptionTypeID: data[0].descriptionTypeID,
      recipientName: data[0].recipientName,
      transactionMode: data[0].transactionMode,
      voucherType: data[0].voucherTypeID,
      payModeID: data[0].payModeID,
      chequeNumber: data[0].chequeNumber == null ? "" : data[0].chequeNumber,
      preparedBy: data[0].preparedBy,
      isInterEstate: data[0].isInterEstate,
      interEstateID: data[0].interEstateID,
      invoiceNo: data[0].invoiceNo,
      payableReferenceNumber: data[0].payableReferenceNumber,
      supplierID: data[0].supplierID,
      tranLedgerAccountID: data[0].tranLedgerAccountID,
      payableDescription: data[0].payableDescription,
    });
    setStatus(data[0].status);
    setRefNo(data[0].referenceNumber);
    setInvoiceNumber(data[0].payableReferenceNumber);
    handleTransactionDateChange(data[0].transactionDate);
    handleInvoiceDateChange(data[0].invoiceDate);
    setIsInterStatus(data[0].isInterEstate)

    let copyArray = data;
    let tranLedgerAccountID = data[0].tranLedgerAccountID;

    let childHeaderModel = {
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      childHeaderID: data[0].childHeaderID
    }

    let accountNameList = await getAccountTypeNames(childHeaderModel);
    let tempArray = [...journalData]
    var filteredArray = copyArray.filter((x) => x.accountTypeName !== tranLedgerAccountID);
    var filteredCreditArray = copyArray.filter((x) => x.accountTypeName === tranLedgerAccountID);
    findCreditAccountTransactionUpdate(filteredCreditArray[0], accountNameList);
    filteredArray.forEach(element => {
      let reuslt = GetAll(element.accountTypeName, accountNameList);
      getAccountDescriptionsNormal(element.accountTypeName);
      tempArray.push(
        {
          accountTypeName: element.accountTypeName,
          childHeaderName: element.childHeaderName,
          description: element.description,
          credit: element.credit,
          debit: element.debit,
          ledgerTransactionID: element.ledgerTransactionID,
          rowID: GenerateRandomID(),
          ledgerAccountCode: element.ledgerAccountCode,
          ledgerAccountName: element.ledgerAccountName,
          descriptionTypeID: element.descriptionTypeID,
          selected: reuslt
        }
      )
    });
    setJournalData(tempArray)
  }

  function findCreditAccountTransactionUpdate(filteredCreditArray, accountNameList) {
    let reuslt = GetAll(filteredCreditArray.accountTypeName, accountNameList);
    getAccountDescriptionsNormal(filteredCreditArray.accountTypeName);
    let model = {
      accountTypeName: filteredCreditArray.accountTypeName,
      description: filteredCreditArray.description,
      credit: filteredCreditArray.credit,
      debit: filteredCreditArray.debit,
      ledgerTransactionID: filteredCreditArray.ledgerTransactionID,
      rowID: 0,
      ledgerAccountCode: filteredCreditArray.ledgerAccountCode,
      ledgerAccountName: filteredCreditArray.ledgerAccountName,
      descriptionTypeID: filteredCreditArray.descriptionTypeID,
      tranLedgerAccountID: filteredCreditArray.tranLedgerAccountID,
      selected: reuslt
    }
    setJournalDataCreditRecordUpdate(model)
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getVoucherTypeList() {
    const voucherTypes = await services.getVoucherTypeList();
    setVoucherTypes(voucherTypes);
    decrypted = atob(referenceNumber.toString());
    if (decrypted == 0) {
      voucherTypes.forEach(x => {
        if (x.screenCode == 'ACCOUNTPAYABLE') {
          setAccountPayable({
            ...accountPayable,
            transactionMode: '0',
            voucherType: parseInt(x.voucherTypeID)
          })
        }
      });
    }
    return voucherTypes;
  }

  async function getTransactionModeList() {
    const transactionModes = await services.getTransactionModeList();
    setTransactionModes(transactionModes);
    return transactionModes
  }

  async function SaveAccountPayable() {
    if (journalData[0].credit != 0 || journalData[0].debit != 0) {
      let newArray = []
      let index = journalData.findIndex(x => x.accountTypeName === 0);
      if (index >= 0) {
        alert.error('Account name is required, please check');
        if (index > 0) {
          journalData.splice(index, 1);
        }
        return;
      }

      var findZeroRecords = journalData.filter(x => parseFloat(x.debit) == 0)
      if (findZeroRecords.length !== 0) {
        alert.error('Amount Should be more than 0');
        return;
      }

      var sameBankAccount = journalData.filter(x => x.accountTypeName == accountPayable.tranLedgerAccountID)
      if (sameBankAccount.length > 0) {
        alert.error('Same Debit and Credit Accounts Not Allowed');
        return;
      }

      let combinedJournalData = [...journalData];

      if (!isUpdate) {
        let sumCredit = 0
        journalData.forEach(X => {
          sumCredit += parseFloat(X.debit)
        });
        let credit = {
          accountTypeName: accountPayable.tranLedgerAccountID,
          credit: sumCredit,
          debit: 0,
          description: journalData[0].description,
          descriptionTypeID: journalData[0].descriptionTypeID,
          disableCreditField: false,
          disableDebitField: true,
          ledgerTransactionID: 0,
          rowID: journalData[0].rowID,
        }
        combinedJournalData.push(credit)
      } else {
        let sumCredit = 0
        journalData.forEach(X => {
          sumCredit += parseFloat(X.debit)
        });

        let credit = {
          accountTypeName: journalDataCreditRecordUpdate.tranLedgerAccountID,
          credit: sumCredit,
          debit: 0,
          description: journalDataCreditRecordUpdate.description,
          descriptionTypeID: journalDataCreditRecordUpdate.descriptionTypeID,
          disableCreditField: false,
          disableDebitField: true,
          ledgerTransactionID: journalDataCreditRecordUpdate.ledgerTransactionID,
          rowID: journalDataCreditRecordUpdate.rowID,
        }
        combinedJournalData.push(credit)
      }

      newArray.push(combinedJournalData)
      index = combinedJournalData.findIndex(x => x.accountTypeName === 0);
      if (index >= 0) {
        alert.error('Account name is required, please check');
        combinedJournalData.splice(index, 1);
        return;
      }

      if (!isUpdate) {
        journalData.forEach(function (part, index) {
          journalData[index].accountTypeName = parseInt(part.accountTypeName);
          journalData[index].debit = parseFloat(part.debit);
          journalData[index].description = part.description;
          journalData[index].descriptionID = part.descriptionTypeID;
        });
        setJournalData(journalData)
      }

      var finalArray = combinedJournalData.filter(e => e.accountTypeName !== 0);
      if (!isUpdate) {
        let saveModel = {
          groupID: accountPayable.groupID,
          factoryID: accountPayable.factoryID,
          transactionTypeID: accountPayable.transactionTypeID,
          referenceNumber: refNo,
          referenceNumberInter: refNoInter,
          chequeNumber: accountPayable.chequeNumber,
          voucherType: accountPayable.voucherType,
          transactionMode: accountPayable.transactionMode,
          transactionModeName: transactionModes.find(mode => mode.payableModeID === accountPayable.transactionMode)?.payableModeName || '',
          voucherCode: voucherCode,
          recipientName: accountPayable.recipientName,
          isActive: true,
          journalData: finalArray,
          transactionDate: selectedTransactionDate,
          invoiceNo: accountPayable.invoiceNo,
          invoiceDate: selectedInvoicenDate,
          date: selectedInvoicenDate,
          dueDate: selectedDueDate,
          status: approveButtonEnabled == true ? parseInt(2) : parseInt(1),
          interEstateID: 0,
          isInterEstate: accountPayable.isInterEstate,
          payableReferenceNumber: invoiceNumber,
          supplierID: accountPayable.supplierID,
          supplierName: suppliers[accountPayable.supplierID]?.name,
          payableDescription: accountPayable.payableDescription,
          tranLedgerAccountID: accountPayable.tranLedgerAccountID,
          tranLedgerAccountName: tranLedgerList[accountPayable.tranLedgerAccountID]
        }
        if (recordAndNewBtnEnable) {
          let response = await services.saveAccountPayable(saveModel);

          if (response.statusCode == "Success") {
            alert.success('Invoice generated successfully');
            clearData();
            navigate('/app/accountPayable/listing');
          }
          else {
            journalData.splice(index, 1);
            alert.error(response.message);
          }
        }
        else {
          let response = await services.saveAccountPayable(saveModel);

          if (response.statusCode == "Success") {
            alert.success('Invoice generated successfully');
            clearData();
            navigate('/app/accountPayable/listing');
          }
          else {
            journalData.splice(index, 1);
            alert.error(response.message);
          }
        }
      }
      else {
        let updateModel = {
          invoiceDetailID: invoiceDetail.invoiceID,
          groupID: accountPayable.groupID,
          factoryID: accountPayable.factoryID,
          transactionTypeID: accountPayable.transactionTypeID,
          referenceNumber: accountPayable.referenceNumber,
          voucherType: accountPayable.voucherType,
          transactionMode: accountPayable.transactionMode,
          recipientName: accountPayable.recipientName,
          chequeNumber: accountPayable.chequeNumber,
          isActive: true,
          journalData: finalArray,
          transactionDate: selectedInvoicenDate,
          invoiceDate: selectedInvoicenDate,
          date: selectedInvoicenDate,
          dueDate: selectedDueDate,
          voucherCode: accountPayable.voucherCode,
          invoiceNo: accountPayable.invoiceNo,
          payableReferenceNumber: accountPayable.payableReferenceNumber
        }
        let response = await services.updateAccountPayable(updateModel);
        if (response.statusCode == "Success") {
          alert.success('Invoice updated successfully');
          clearData();
          navigate('/app/accountPayable/listing');
        }
        else {
          journalData.splice(index, 1);
          alert.error(response.message);
        }
      }
    }
    else {
      alert.error("please enter Debit/Credit Values");
    }
  }

  function concatenate(voucherType, transactionMode) {
    const voucherCode = voucherTypes.find(x => x.voucherTypeID === voucherType)
    const transactionCode = transactionModes.find(x => x.payableModeID === transactionMode)
    const concatCode = transactionCode.payableModeCode.concat(voucherCode.voucherTypeCode)
    setVoucherCode(concatCode)
    return concatCode;
  }

  function GetAll(ledgerAccountID, accountTypeNames) {
    const result = accountTypeNames.filter((a) => a.ledgerAccountID.toString() === ledgerAccountID.toString())
    return result;
  }

  function GetAllChildHeaders(childHeaderID, childHeaderNames) {
    const result = childHeaderNames.filter((a) => a.childHeaderID.toString() === childHeaderID.toString())
    return result;
  }

  function generateDropownForVoucherList(dataList) {
    let items = []
    if (dataList != null) {
      voucherTypes.forEach(x => {
        if (x.screenCode == 'ACCOUNTPAYABLE') {
          items.push(<MenuItem key={x.voucherTypeID} value={x.voucherTypeID}>{x.voucherTypeName}</MenuItem>)
        }
      });
    }
    return items
  }

  function generateDropownForTransactionModeList(dataList) {
    let items = [];
    if (dataList != null) {
      transactionModes
        .filter(x => x.payableModeID === 1)
        .forEach(x => {
          items.push(
            <MenuItem key={x.payableModeID} value={x.payableModeID}>
              {x.payableModeName}
            </MenuItem>
          );
        });
    }
    return items;
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  async function transactionModeChange(e) {
    const target = e.target;
    const value = target.value
    var voucherCode = concatenate(accountPayable.voucherType, value);
    setVoucherCodeRef(voucherCode)
    //trackPromise(getReferenceNumber(voucherCode));
  }

  function handleChangeForm(e) {
    const target = e.target;
    const value = target.value
    setAccountPayable({
      ...accountPayable,
      [e.target.name]: value
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  function calDebitTotal() {
    let sum = 0;
    journalData.forEach(x => {
      sum += parseFloat(x.debit);
      x.debit = parseFloat(x.debit);
      x.ledgerTransactionID = parseFloat(x.ledgerTransactionID);
      x.description = x.description;
      x.descriptionTypeID = x.descriptionTypeID;
    });
    return sum.toFixed(2);
  }

  function findLoginUser() {
    return tokenDecoder.getUserNameFromToken();
  }

  function Cancel() {
    navigate('/app/accountPayable/listing');
  }

  const RecordAndNew = () => {
    setRecordAndNewBtnEnable(true);
    setApproveButtonEnabled(false);
  }

  const ApproveClick = () => {
    setRecordAndNewBtnEnable(false);
    setApproveButtonEnabled(true);
  }

  function clearData() {
    setAccountPayable({
      ...accountPayable,
      transactionTypeID: '0',
      referenceNumber: '',
      description: '',
      descriptionTypeID: '',
      payModeID: '0',
      chequeNumber: '',
      isActive: true,
      preparedBy: '',
      updatedBy: '',
      voucherCode: '',
      transactionMode: '0',
      recipientName: '',
      payableReferenceNumber: ''
    });
    setJournalData([{
      accountTypeName: 0,
      childHeaderName: 0,
      credit: 0,
      debit: 0,
      description: "",
      descriptionTypeID: '',
      ledgerTransactionID: 0,
      rowID: GenerateRandomID()
    }]);
    handleTransactionDateChange(new Date());
    handleInvoiceDateChange(new Date());
    handleDueDateChange(new Date().toISOString());
    setRefNo('');
    setVoucherCode('');
  }

  const handleDeleteRow = (rowID) => {
    const updatedJournalData = journalData.filter((row) => row.rowID !== rowID);
    setJournalData(updatedJournalData);
  };

  async function handleChildHeaderChange(e, data, rowID) {
    if (data === undefined || data === null)
      return;

    let valueV = data["childHeaderID"];

    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));

    let childHeaderModel = {
      groupID: accountPayable.groupID,
      factoryID: accountPayable.factoryID,
      childHeaderID: valueV
    }

    const accountNameList = await services.getLedgerAccountNamesForDatagrid(childHeaderModel);
    setAccountTypeNames(accountNameList);

    let result = GetAllChildHeaders(valueV, childHeaderNames)

    if (newArr[idx].childHeaderID !== parseInt(valueV)) {
      newArr[idx] = {
        ...newArr[idx],
        childHeaderID: parseInt(valueV),
        selected: 0,
        selected2: result,
      };
    } else {
      newArr[idx] = {
        ...newArr[idx],
        childHeaderID: parseInt(valueV),
        selected: 0,
        selected2: result,

      };
    }
    setJournalData(newArr)
  }

  async function handleSearchDropdownChange(e, data, rowID) {
    if (data === undefined || data === null)
      return;
    let valueV = data["ledgerAccountID"];
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    const descriptions = await services.getAccountDescriptions(valueV);
    const newDesc = { ...accountDescriptions };
    delete newDesc[rowID];

    if (descriptions.length > 0) {
      newDesc[rowID] = descriptions;
    }
    setAccountDescriptions(newDesc);

    let reuslt = GetAll(valueV, accountTypeNames);
    if (newArr[idx].accountTypeName !== parseInt(valueV)) {
      newArr[idx] = {
        ...newArr[idx],
        accountTypeName: parseInt(valueV),
        selected: reuslt,
        debit: 0,
        credit: 0,
        description: "",
        descriptionTypeID: 0
      };
    } else {
      newArr[idx] = {
        ...newArr[idx],
        accountTypeName: parseInt(valueV),
        selected: reuslt
      };
    }
    setJournalData(newArr)
  }

  function changeText(e, rowID, inputType, IDvalue = 0, desc = null) {
    let target = e?.target ? e.target : '';
    let value = target !== '' ? target.value : '';
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    const AccountTypeName = newArr[idx].accountTypeName;
    for (let i = 0; i < newArr.length; i++) {
      if (i !== idx && newArr[i].accountTypeName === AccountTypeName) {
        if (inputType === 'credit' && parseInt(newArr[i].debit) !== 0) {
          alert.error('No Credit amounts are allowed for this Account.');
          return;
        }
        else if (inputType === 'debit' && parseInt(newArr[i].credit) !== 0) {
          alert.error('No Debit amounts are allowed for this Account.');
          return;
        }
      }
    }
    if (inputType.includes('descriptionType')) {
      newArr[idx] = { ...newArr[idx], descriptionType: desc, descriptionTypeID: IDvalue };
    } else if (inputType === "description") {
      newArr[idx] = { ...newArr[idx], description: value };
    } else if (inputType === "credit") {

      var reg = new RegExp('^[\.0-9]*$');

      if (reg.test(value) == false) {
        alert.error("Allow Only Numbers")
        return;
      }

      let debitBool = false
      let creditBool = false
      if (parseFloat(value.toString()) > 0) {
        debitBool = true;
        creditBool = false
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = { ...newArr[idx], credit: (value === "" ? 0 : value) };
    } else {

      var reg = new RegExp('^[\.0-9]*$');
      if (reg.test(value) == false) {
        alert.error("Allow Only Numbers")
        return;
      }

      let debitBool = false
      let creditBool = false
      if (parseFloat(value.toString()) > 0) {
        debitBool = false;
        creditBool = true
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = { ...newArr[idx], debit: (value === "" ? 0 : value) };
    }
    setJournalData(newArr)
  }

  function GenerateRandomID() {
    const d = new Date();
    let ms = d.valueOf();
    let rendomValue = ((ms + Math.floor(Math.random() * 10000)) - 12) + ((ms - 128) + (ms * 512))
    return rendomValue;
  }

  function onKeyDown(e, id, data) {
    if (e.key === "Tab" && !isUpdate) {
      if (data.credit != 0 || data.debit != 0) {
        if (journalData[journalData.length - 1].rowID.toString() === id.toString()) {
          let ID = GenerateRandomID()
          journalData.push({ accountTypeName: 0, credit: 0, debit: 0, ledgerTransactionID: 0, rowID: ID, selected: [] })
          var result = refNo == undefined ? 0 : refNo.substring(0, 3);
          setJournalData(journalData)
          if (result == 'CHP') {
            getChequeNumber(data)
          }
        }
      }
      else {
        alert.error("please enter Debit/Credit Values");
      }
    }
  };

  async function getChequeNumber(data) {
    let response = await services.getChequeNumber(data.accountTypeName);
    if (response.data == null) {
      alert.error(response.message);
    }
    else {
      setAccountPayable({
        ...accountPayable,
        chequeNumber: response.data
      });
    }
  }

  async function getTranLedgerList() {
    const transaction = await services.getTranLedgerListForDropdown(accountPayable.factoryID);
    setTranLedgerList(transaction);
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: accountPayable.groupID,
              factoryID: accountPayable.factoryID,
              referenceNumber: referenceNumber,
              recipientName: accountPayable.recipientName,
              description: accountPayable.description,
              descriptionTypeID: accountPayable.descriptionTypeID,
              voucherType: accountPayable.voucherType,
              transactionMode: accountPayable.transactionMode,
              chequeNumber: accountPayable.chequeNumber,
              isActive: accountPayable.isActive,
              isInterEstate: accountPayable.isInterEstate,
              interEstateID: accountPayable.interEstateID,
              invoiceNo: accountPayable.invoiceNo,
              payableReferenceNumber: accountPayable.payableReferenceNumber,
              tranLedgerAccountID: accountPayable.tranLedgerAccountID,
              supplierID: accountPayable.supplierID,
              payableDescription: accountPayable.payableDescription
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
                referenceNumber: Yup.string().required('Reference number required'),
                voucherType: Yup.number().required('Voucher Type required').min("1", 'Voucher Type required'),
                transactionMode: Yup.number().required('Transaction Mode required').min("1", 'Transaction Mode required'),
                supplierID: Yup.number().when("transactionMode", {
                  is: 1,
                  then: Yup.number().required('Supplier required').min(1, 'Supplier required'),
                  otherwise: Yup.number().nullable(),
                }),
                invoiceNo: Yup.string()
                  .required('Invoice number required')
                  .test('no-spaces', 'Spaces are not allowed in the Invoice number', (value) => /^[^\s]+$/.test(value))
                  .test('not-only-zeros', 'Invoice number cannot be 0', (value) => !/^[0]+$/.test(value))
                  .test('unique-invoice', 'Invoice number already exists for this supplier', function (value) {
                    if (!value || !this.parent.supplierID || this.parent.supplierID === '0') return true;
                    return !supplierInvoiceNumbers.some(invoice =>
                      invoice.invoiceNumber.toLowerCase() === value.toLowerCase()
                    );
                  }),
                tranLedgerAccountID: Yup.number().required('Ledger Account required').min("1", 'Ledger Account required'),
                chequeNumber: Yup.string().when("payModeID",
                  {
                    is: val => val == '',
                    then: Yup.string().required('Cheque number required'),
                  }),
                interEstateID: Yup.number().when('isInterEstate', {
                  is: true,
                  then: Yup.number()
                    .required('Inter Estate required')
                    .min(1, 'Inter Estate required'),
                }),
              })
            }
            onSubmit={(event) => trackPromise(SaveAccountPayable(event))}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              values,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForm(e)}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false,
                              }}
                              disabled={isInterStatus}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForm(e)}
                              value={accountPayable.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false,
                              }}
                              disabled={isInterStatus}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                              Transaction Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                variant='inline'
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedTransactionDate}
                                minDate={financialYearStartDate}
                                maxDate={maxDate}
                                disabled={isUpdate || dateDisable || isInterStatus}
                                InputProps={{
                                  readOnly: true,
                                }}
                                onChange={(e) => {
                                  handleTransactionDateChange(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          {Hidden == true ? <Grid item md={3} xs={12}>
                            <InputLabel shrink id="payableReferenceNumber">
                              Reference No *
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="payableReferenceNumber"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForm(e)}
                              value={invoiceNumber}
                              variant="outlined"
                              InputProps={{
                                readOnly: true,
                              }}
                              disabled={isInterStatus}
                            />
                          </Grid> : null}

                          {Hidden == true ?
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="voucherType">
                                Voucher Type *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.voucherType && errors.voucherType)}
                                fullWidth
                                helperText={touched.voucherType && errors.voucherType}
                                name="voucherType"
                                size='small'
                                onBlur={handleBlur}
                                onChange={(e) => handleChangeForm(e)}
                                value={accountPayable.voucherType}
                                variant="outlined"
                                id="voucherType"
                                InputProps={{
                                  readOnly: isUpdate ? true : false,
                                }}
                                disabled={isInterStatus}
                              >
                                <MenuItem value="0">--Select Voucher Type--</MenuItem>
                                {generateDropownForVoucherList(voucherTypes)}
                              </TextField>
                            </Grid> : null}

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="transactionMode">
                              Transaction Mode *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.transactionMode && errors.transactionMode)}
                              fullWidth
                              helperText={touched.transactionMode && errors.transactionMode}
                              name="transactionMode"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChangeForm(e)
                                trackPromise(transactionModeChange(e))
                              }}
                              value={accountPayable.transactionMode}
                              variant="outlined"
                              id="transactionMode"
                              InputProps={{
                                readOnly: isUpdate ? true : false,
                              }}
                              disabled={isInterStatus}
                            >
                              <MenuItem value="0">--Select Transaction Mode--</MenuItem>
                              {generateDropownForTransactionModeList(transactionModes)}
                            </TextField>
                          </Grid>

                          {!isUpdate ?
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="supplierID"> Supplier * </InputLabel>
                              <Autocomplete
                                id="supplierItem"
                                key={isCleared}
                                options={suppliersAuto}
                                getOptionLabel={(option) => option.supplierName}
                                onChange={(e, value) => handleChangeSupplier(value, e)}
                                defaultValue={null}
                                disabled={accountPayable.transactionMode !== 1}
                                renderInput={(params) =>
                                  <TextField {...params}
                                    fullWidth
                                    error={Boolean(
                                      touched.supplierID && errors.supplierID
                                    )}
                                    helperText={touched.supplierID && errors.supplierID}
                                    name="supplierID"
                                    onBlur={handleBlur}
                                    onChange={e => handleChangeSupplier(e)}
                                    value={values.supplierID}
                                    variant="outlined"
                                    size='small'
                                    placeholder="--Select Supplier--"
                                  />
                                }
                              />
                            </Grid>
                            :
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="supplierID">
                                Supplier *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.supplierID && errors.supplierID
                                )}
                                fullWidth
                                helperText={touched.supplierID && errors.supplierID}
                                name="supplierID"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeSupplier(e)}
                                value={values.supplierID}
                                disabled={accountPayable.transactionMode !== 1}
                                InputProps={{
                                  readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false,
                                }}
                                variant="outlined"
                                id="supplierID"
                              >
                                <MenuItem value="0">--Select Supplier--</MenuItem>
                                {generateDropDownMenuWithTwoValues(suppliers)}
                              </TextField>
                            </Grid>
                          }
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="invoiceNo">
                              Invoice No *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.invoiceNo && errors.invoiceNo)}
                              fullWidth
                              helperText={touched.invoiceNo && errors.invoiceNo}
                              name="invoiceNo"
                              size="small"
                              onBlur={handleBlur}
                              onChange={handleInvoiceNoChange}
                              value={accountPayable.invoiceNo}
                              InputProps={{
                                readOnly: isUpdate,
                              }}
                              variant="outlined"
                            />
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                              Entry Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                variant='inline'
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedInvoicenDate}
                                minDate={financialYearStartDate}
                                maxDate={maxDate}
                                disabled={dateDisable || isInterStatus || !isUpdate}
                                InputProps={{
                                  readOnly: true,
                                }}
                                onChange={(e) => {
                                  handleInvoiceDateChange(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          {isUpdate ?
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="referenceNumber">
                                Voucher Code *
                              </InputLabel>
                              <TextField
                                error={Boolean(touched.referenceNumber && errors.referenceNumber)}
                                fullWidth
                                helperText={touched.referenceNumber && errors.referenceNumber}
                                name="referenceNumber"
                                size='small'
                                onBlur={handleBlur}
                                onChange={(e) => handleChangeForm(e)}
                                value={accountPayable.referenceNumber}
                                variant="outlined"
                                InputProps={{
                                  readOnly: true,
                                }}
                                disabled={isInterStatus}
                              />
                            </Grid>
                            : null}

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="tranLedgerAccountID">
                              Ledger Account *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.tranLedgerAccountID &&
                                errors.tranLedgerAccountID
                              )}
                              fullWidth
                              helperText={
                                touched.tranLedgerAccountID &&
                                errors.tranLedgerAccountID
                              }
                              name="tranLedgerAccountID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => {
                                handleChangeForm(e);
                              }}
                              value={accountPayable.tranLedgerAccountID}
                              variant="outlined"
                              id="tranLedgerAccountID"
                              disabled={isInterStatus || isUpdate}
                              InputProps={{
                                readOnly: isUpdate ? true : false
                              }}
                            >
                              <MenuItem value="0">
                                --Select Ledger Account--
                              </MenuItem>
                              {generateDropDownMenu(
                                tranLedgerList
                              )}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="payableDescription">
                              Description
                            </InputLabel>
                            <TextField
                              fullWidth
                              placeholder="--Enter Description --"
                              name="payableDescription"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={accountPayable.payableDescription}
                              disabled={isInterStatus}
                              InputProps={{
                                readOnly: isUpdate,
                              }}
                              variant="outlined"
                            />
                          </Grid>

                          {/* <Grid item md={3} xs={12}>
                            <FormControlLabel
                              style={{ marginTop: '25px' }}
                              control={
                                <Switch
                                  checked={accountPayable.isInterEstate}
                                  onChange={(e) => isInterEstatehandleChange(e)}
                                  name="isInterEstate"
                                  disabled={isUpdate || isInterStatus}
                                />
                              }
                              label="Is Inter Estate"
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="interEstateID">
                              Inter Estate *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.interEstateID && errors.interEstateID
                              )}
                              fullWidth
                              helperText={touched.interEstateID && errors.interEstateID}
                              name="interEstateID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={accountPayable.interEstateID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!interEstateButtonEnable || isUpdate || isInterStatus}
                            >
                              <MenuItem value="0">--Select Inter Estate--</MenuItem>
                              {generateDropDownMenuForInterEstate(factories, accountPayable.factoryID)}
                            </TextField>
                          </Grid> */}
                        </Grid>

                        {Hidden == true ?
                          <Grid container spacing={3}>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="chequeNumber">
                                Due Date
                              </InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  fullWidth
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  margin="dense"
                                  id="date-picker-inline"
                                  value={selectedDueDate}
                                  disabled={isInterStatus}
                                  onChange={(e) => {
                                    handleDueDateChange(e)
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                  inputProps={{
                                    readOnly: true
                                  }}
                                  autoOk
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="chequeNumber">
                                Cheque Number
                              </InputLabel>
                              <TextField
                                error={Boolean(touched.chequeNumber && errors.chequeNumber)}
                                fullWidth
                                helperText={touched.chequeNumber && errors.chequeNumber}
                                name="chequeNumber"
                                onBlur={handleBlur}
                                onChange={(e) => handleChangeForm(e)}
                                value={accountPayable.chequeNumber}
                                variant="outlined"
                                disabled={isDisableButton || isInterStatus}
                              />
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="recipientName">
                                Recipient Name
                              </InputLabel>
                              <TextField
                                error={Boolean(touched.recipientName && errors.recipientName)}
                                fullWidth
                                helperText={touched.recipientName && errors.recipientName}
                                name="recipientName"
                                onBlur={handleBlur}
                                onChange={(e) => handleChangeForm(e)}
                                value={accountPayable.recipientName}
                                variant="outlined"
                                disabled={isDisableButton || isInterStatus}
                              />
                            </Grid>
                          </Grid> : null}

                      </CardContent>
                      <CardContent height="auto">
                        <Box style={{ border: "1px solid gray" }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Child Header Name *</TableCell>
                                <TableCell>Account Name *</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Description Category</TableCell>
                                <TableCell>Amount *</TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {journalData.map((object) => {
                                let ID = object.rowID;
                                return (
                                  <TableRow key={ID}>
                                    <TableCell className="table-cell" style={{ width: "13rem" }}>
                                      {isUpdate ? (
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          name={ID}
                                          onBlur={handleBlur}
                                          onChange={(e) => changeText(e, ID, "childHeader")}
                                          disabled={true}
                                          value={object.childHeaderName}
                                          fullWidth
                                        />
                                      ) : (
                                        <Autocomplete
                                          id={ID.toString()}
                                          options={childHeaderNames}
                                          size="small"
                                          getOptionLabel={(option) => option.childHeaderName}
                                          onChange={(e, value) => handleChildHeaderChange("childHeader", value, ID)}
                                          value={object.selected2?.[0] || null}
                                          disabled={isUpdate || isInterStatus}
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth variant="outlined" placeholder="--Select Child Header--" />
                                          )}
                                        />
                                      )}
                                    </TableCell>

                                    <TableCell className="table-cell" style={{ width: "13rem" }}>
                                      {isUpdate ? (
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          name={ID}
                                          onBlur={handleBlur}
                                          disabled={true}
                                          value={object.ledgerAccountName}
                                          fullWidth
                                        />
                                      ) : (
                                        <Autocomplete
                                          id={ID.toString()}
                                          options={accountTypeNames}
                                          size="small"
                                          getOptionLabel={(option) => option.ledgerAccountName}
                                          onChange={(e, value) => handleSearchDropdownChange("accountName", value, ID)}
                                          value={object.selected?.[0] || null}
                                          disabled={isUpdate || isInterStatus}
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth variant="outlined" placeholder="--Select Account--" />
                                          )}
                                        />
                                      )}
                                    </TableCell>

                                    <TableCell className="table-cell" style={{ width: "13rem" }}>
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        placeholder="--Enter Description--"
                                        name={ID}
                                        onBlur={handleBlur}
                                        onChange={(e) => changeText(e, ID, "description")}
                                        disabled={isUpdate || isInterStatus}
                                        value={object.description}
                                        fullWidth
                                      />
                                    </TableCell>

                                    <TableCell className="table-cell" style={{ width: "13rem" }}>
                                      {isUpdate ? (
                                        <TextField
                                          select
                                          fullWidth
                                          name="descriptionType"
                                          size="small"
                                          onBlur={handleBlur}
                                          onChange={handleChangeForm}
                                          value={object.descriptionTypeID}
                                          disabled={isUpdate}
                                          variant="outlined"
                                        >
                                          <MenuItem value="0">--Select Description Type--</MenuItem>
                                          {generateDropDownMenu(accountDescriptionsType)}
                                        </TextField>
                                      ) : (
                                        <Autocomplete
                                          id={ID.toString()}
                                          key={object.descriptionTypeID}
                                          options={accountDescriptions?.[ID] ?? []}
                                          size="small"
                                          getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.accountDescription
                                          }
                                          onChange={(e, value) => {
                                            if (value?.accountDescriptionTypeID !== undefined) {
                                              changeText(e, ID, "descriptionType", value.accountDescriptionTypeID, value.accountDescription);
                                            }
                                          }}
                                          value={
                                            accountDescriptions?.[ID]?.find(
                                              (desc) => desc.accountDescriptionTypeID === object.descriptionTypeID
                                            ) || null
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth variant="outlined" placeholder="--Select Description Type--" />
                                          )}
                                        />
                                      )}
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ width: "13rem" }}>
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        name={ID}
                                        onBlur={handleBlur}
                                        onChange={(e) => changeText(e, ID, "debit")}
                                        value={object.debit}
                                        fullWidth
                                        onKeyDown={(e) => onKeyDown(e, ID, object)}
                                        disabled={isInterStatus}
                                      />
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ width: "5rem" }}>
                                      {!isUpdate && !isInterStatus && journalData.length > 1 && journalData.indexOf(object) !== 0 && (
                                        <DeleteIcon
                                          style={{
                                            color: "red",
                                            cursor: "pointer"
                                          }}
                                          size="small"
                                          onClick={() => handleDeleteRow(ID)}
                                        />
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>

                          </Table>
                        </Box>
                      </CardContent>
                      <CardContent>
                        <Box border={1} borderColor="#626964" padding="1rem">
                          <Grid container md={12} spacing={2} style={{ marginLeft: '1rem' }}>
                            <Grid item md={5} xs={12}>
                              <InputLabel><b>Total Amount (Rs)</b> {": "}
                                <CountUp decimals={2} separator=',' end={calDebitTotal()} duration={0.1} />
                              </InputLabel>
                            </Grid>
                            <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                              <InputLabel><b>Prepared By</b> {isUpdate ? ": " + accountPayable.preparedBy : ": " + findLoginUser()}</InputLabel>
                            </Grid>
                            {isUpdate && accountPayable.updatedBy && (
                              <Grid container item md={12} alignItems="center" style={{ marginTop: '1rem' }}>
                                <Grid item md={5} xs={12}>
                                  <InputLabel><b>Updated By</b> {": " + findLoginUser()}</InputLabel>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnCancel"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorCancel}
                          onClick={() => Cancel()}
                          disabled={isInterStatus}
                        >
                          Cancel
                        </Button>
                        {!isUpdate ?
                          <Button
                            color="primary"
                            id="btnRecordAndNew"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecordAndNew}
                            onClick={RecordAndNew}
                          >
                            Send to Approve
                          </Button> : null}
                        {/* {permissionList.isApproveButtonEnabled == false && !isUpdate ?
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={RecordClick}
                          >
                            Record
                          </Button> : null} */}
                        {permissionList.isApproveButtonEnabled == true && !isUpdate ?
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={ApproveClick}
                          >
                            Approve
                          </Button> : null}
                        {isUpdate && status != 2 ?
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            disabled={isInterStatus}
                          >
                            Update
                          </Button> : null}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment >
  );
};
